import { writable } from 'svelte/store'

export interface Toast {
  id: number
  message: string
  type: 'ok' | 'err' | 'info'
  timeout?: number
}

export const toasts = writable<Toast[]>([])

let seq = 0
export function notify(message: string, type: Toast['type'] = 'info', timeout = 4500) {
  const id = ++seq
  toasts.update(list => [...list, { id, message, type, timeout }])
  if (timeout) setTimeout(() => dismiss(id), timeout)
}

export function dismiss(id: number) {
  toasts.update(list => list.filter(t => t.id !== id))
}
